import React, { useEffect, useState } from "react";
import CustomBottomSheet from "./CustomBottomSheet";
import { Button, Container } from "reactstrap";
import { Box, Modal } from "@mui/material";
import config from "../../../../config.json";
import { useNavigate } from "react-router-dom";
import { postServices } from "../../../../apiServices/apiServices";
import toast from "react-hot-toast";

function VariationCustomBottomSheet(props) {
  const url = config.url;
  const access_token = localStorage.getItem("user-access-token");
  const navigate = useNavigate();

  const [colorId, setColorId] = useState();
  const [variationData, setVariationData] = useState(); // selected color
  const [sizeSelection, setSizeSelection] = useState(); // selected size
  const [selectedBranding, setSelectedBranding] = useState(); // selected branding

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    padding: "20px 14px",
    outline: "none",
    borderRadius: "10px",
  };

  useEffect(() => {
    if (
      !props.data?.productColorInfo ||
      props.data.productColorInfo.length === 0
    ) {
      return;
    }

    const firstColor = props.data.productColorInfo[0];
    setColorId(firstColor.product_color_id);
    setVariationData(firstColor);

    const firstSize = firstColor.productDataInfo?.[0] || null;
    setSizeSelection(firstSize);

    const firstBranding = firstSize?.brandings?.[0] || null;
    setSelectedBranding(firstBranding || null);
  }, [props.data]);

  const handleAddToCart = async () => {
    if (!variationData) {
      toast.error("Please select color..!");
      return;
    }
    if (!sizeSelection) {
      toast.error("Please select size..!");
      return;
    }
    if (!selectedBranding) {
      toast.error("Please select branding..!");
      return;
    }

    try {
      const res = await postServices(
        `/api/wishlist/add_wishlist`,
        access_token,
        {
          product_id: props.data?.product_id,
          color_id: colorId,
          variation_id: sizeSelection.product_data_id,
          branding_id: selectedBranding.branding_id,
        }
      );
      props.setIsBottomNav(false);
      if (res.responseCode === 200) {
        toast.success("Product added to wishlist successfully...");
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleLoginPage = () => {
    navigate("/login");
  };

  // COLOR CLICK – resets size & branding
  const handleVariationClick = (color) => {
    setVariationData(color);
    setColorId(color.product_color_id);

    const firstSize = color.productDataInfo?.[0] || null;
    setSizeSelection(firstSize);

    const firstBranding = firstSize?.brandings?.[0] || null;
    setSelectedBranding(firstBranding || null);
  };

  // SIZE CLICK – resets branding for that size
  const handleSizeClick = (size) => {
    setSizeSelection(size);
    if (size.brandings && size.brandings.length > 0) {
      setSelectedBranding(size.brandings[0]);
    } else {
      setSelectedBranding(null);
    }
  };

  const handleBrandingClick = (branding) => {
    setSelectedBranding(branding);
  };

  return (
    <>
      {access_token ? (
        <CustomBottomSheet
          isBottomNav={props.isBottomNav}
          onClose={() => props.setIsBottomNav(false)}
        >
          <Container className="mx-5 sm:mx-10 my-3 sm:my-5">
            {/* HEADER + PRICE */}
            <Container className="flex items-center gap-5">
              <Container className="capitalize">
                <p className="text-slate-600 font-medium text-sm sm:text-base">
                  {props.data?.categoryInfo?.category_name}
                </p>
                <p className="text-base sm:text-lg text-black font-semibold">
                  {props.data?.product_name}
                </p>

                <Container className="flex items-end mb-3">
                  {props.data && (
                    <h1
                      className="text-lg font-semibold"
                      style={{
                        marginRight:
                          sizeSelection?.sales_price == 0 ? "0" : "1rem",
                      }}
                    >
                      {sizeSelection?.sales_price == 0
                        ? null
                        : "₹ " + sizeSelection?.sales_price}
                    </h1>
                  )}
                  {props.data && (
                    <h1
                      className="text-md font-semibold"
                      style={{
                        color:
                          sizeSelection?.sales_price == 0
                            ? "#353535"
                            : "#64748B",
                        lineHeight: sizeSelection?.sales_price
                          ? "1.75rem"
                          : "2.25rem",
                      }}
                    >
                      {sizeSelection?.sales_price == 0 ? (
                        "₹ " + sizeSelection?.price
                      ) : (
                        <del>{"₹ " + sizeSelection?.price}</del>
                      )}
                    </h1>
                  )}
                  {props.data && sizeSelection?.offer_value > 0 && (
                    <p className="ml-3 text-md font-semibold text-green-600">
                      {sizeSelection?.offer_value + "% OFF"}
                    </p>
                  )}
                </Container>
              </Container>
            </Container>

            <Container>
              {/* COLOR SELECTION */}
              <p className="my-2 sm:my-2 text-base font-semibold">
                Select Color
              </p>
              <Container className="flex gap-2 flex-wrap items-center text-center">
                {props.data?.productColorInfo?.map((item, i) => (
                  <Container
                    key={i}
                    onClick={
                      colorId === item.product_color_id
                        ? undefined
                        : () => handleVariationClick(item)
                    }
                    className={`text-center cursor-pointer capitalize rounded-md ${
                      colorId === item.product_color_id
                        ? "border-2 border-slate-500 opacity-100"
                        : "opacity-50"
                    }`}
                  >
                    <img
                      src={url + (item.productDataInfo?.[0]?.image?.[0] || "")}
                      alt={item.productDataInfo?.[0]?.variation || ""}
                      className="w-16 rounded-md h-10 object-cover"
                    />
                    <p className="text-xs">{item.colors}</p>
                  </Container>
                ))}
              </Container>

              {/* SIZE SELECTION */}
              {variationData?.productDataInfo &&
                variationData.productDataInfo.length > 0 && (
                  <>
                    <p className="my-2 sm:my-2 text-base font-semibold">
                      Select Size{" "}
                      <span className="text-xs">(breadth x length) in cm</span>
                    </p>
                    <Container className="flex gap-2 flex-wrap items-center text-center">
                      {variationData.productDataInfo.map((size) => (
                        <button
                          key={size.product_data_id}
                          onClick={() => handleSizeClick(size)}
                          className={`px-3 py-1 rounded-full text-xs border-2 ${
                            sizeSelection?.product_data_id ===
                            size.product_data_id
                              ? "bg-[#800000] text-white border-[#800000]"
                              : "border-[#800000] text-slate-700 bg-transparent"
                          }`}
                        >
                          {size.breadth_in_mm} x {size.length_in_mm}
                        </button>
                      ))}
                    </Container>
                  </>
                )}

              {/* BRANDING SELECTION */}
              {sizeSelection?.brandings?.length > 0 && (
                <>
                  <p className="my-2 sm:my-2 text-base font-semibold">
                    Select Branding
                  </p>
                  <Container className="flex gap-2 flex-wrap items-center text-center">
                    {sizeSelection.brandings.map((brand, i) => (
                      <Container
                        key={i}
                        onClick={() => handleBrandingClick(brand)}
                        className={`text-center cursor-pointer px-3 py-1 capitalize rounded-full ${
                          selectedBranding &&
                          selectedBranding.branding_id === brand.branding_id
                            ? "border-2 border-[#800000] opacity-100 text-white bg-[#800000]"
                            : "border-2 border-[#800000]"
                        }`}
                      >
                        <p className="text-xs">{brand.name}</p>
                      </Container>
                    ))}
                  </Container>
                </>
              )}

              <Button
                type="button"
                onClick={handleAddToCart}
                className="bg-[#800000] w-full text-white font-semibold outline-none py-3 mt-2 rounded-lg active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
              >
                Add To Wishlist
              </Button>
            </Container>
          </Container>
        </CustomBottomSheet>
      ) : (
        <Modal
          open={props.isBottomNav}
          onClose={() => props.setIsBottomNav(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <p id="modal-modal-description">
              Register Now to avail your discount on Bulk Gifting
            </p>
            <Container className="flex justify-end">
              <Button
                onClick={handleLoginPage}
                className="bg-[#800000] px-6 py-1 rounded-lg text-white font-semibold active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
              >
                Login
              </Button>
            </Container>
          </Box>
        </Modal>
      )}
    </>
  );
}

export default VariationCustomBottomSheet;
